export default __webpack_public_path__ + "static/media/CustomViewMemberPerks.296ddac3.png";